/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Valve_Add_SubtitleInputs */



/**
* | output |
* | --- |
* | "Place the thermostatic heads on the plan" |
*
* @param {Valve_Add_SubtitleInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const valve_add_subtitle = /** @type {((inputs?: Valve_Add_SubtitleInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Valve_Add_SubtitleInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Place the thermostatic heads on the plan")
	return /** @type {LocalizedString} */ ("Placez les têtes thermostatiques sur le plan")
});